import Dodone from 'models/dodone'
import getModelMember from 'braindamage/api/getModelMember'
import { useQuery } from '@tanstack/react-query'

export default ({ dodoneId }) => {
  return useQuery({
    queryKey: ['dodone', dodoneId],
    queryFn: async () => {
      const data = await getModelMember(`/api/dodones/${dodoneId}`, Dodone)
      return data
    }
  })
}
